import React from "react"

export const PageTemplate = ({title, content, cols}) => (
    <div className="main-content">
        <div className="col-12"><h1>{title}</h1></div>
        <div className={`content col-${cols} small-col-12`} dangerouslySetInnerHTML={{__html: content}} />
    </div>
)

export default PageTemplate